<template>
  <div class="companyFiles">
    <el-divider content-position="left">客户记账材料</el-divider>
    <el-row style="padding: 0 0.2rem">
      <el-col :span="24" v-if="counts" style="line-height: 28px">
        <span> 今日上传公司：{{ counts.toDayFile }}</span>
        <span>今日快递公司：{{ counts.todayExpress }}</span>
        <span> 本月上传公司：{{ counts.monFile }}</span>
        <span>本月快递公司：{{ counts.monExpress }}</span>
      </el-col>
    </el-row>
    <el-row style="padding: 0 0.2rem; margin-bottom: 0.2rem">
      <el-col :span="18">
        <el-select
          v-model="searchArr.company_id"
          filterable
          remote
          reserve-keyword
          placeholder="请输入公司名称筛选公司"
          size="mini"
          clearable
          :remote-method="searchRemoteCompanyMethod"
          :loading="searchLoading"
          @change="handleSearchCompanyChange"
        >
          <el-option
            v-for="searchCompany in searchCompanies"
            :key="searchCompany.id"
            :label="searchCompany.company_name"
            :value="searchCompany.id"
          >
          </el-option>
        </el-select>
        <el-date-picker
          size="mini"
          v-model="searchArr.created_at"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="上传时间"
          end-placeholder="上传时间"
          :picker-options="refundPicker"
          @change="createdAtChange"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-popover placement="bottom-start" v-model="visible" width="450">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="财税负责人" prop="leader_id">
              <el-cascader
                v-model="searchArr.leader_id"
                placeholder="请选择财税负责人"
                :options="adminUsersAddition"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="理票会计" prop="acc_id">
              <el-cascader
                v-model="searchArr.acc_id"
                placeholder="请选择理票会计"
                :options="adminUsersAddition"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="客服会计" prop="ass_id">
              <el-cascader
                v-model="searchArr.ass_id"
                placeholder="请选择客服会计"
                :options="adminUsersAddition"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="记账报税会计" prop="advisory_id">
              <el-cascader
                v-model="searchArr.advisory_id"
                placeholder="请选择记账报税会计"
                :options="adminUsersAddition"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="开票会计" prop="invoice_id">
              <el-cascader
                v-model="searchArr.invoice_id"
                placeholder="请选择开票会计"
                :options="adminUsersAddition"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="业务员" prop="saler_id">
              <el-cascader
                v-model="searchArr.saler_id"
                placeholder="请选择业务员"
                :options="adminUsersAddition"
                size="mini"
                :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="快递上传人" prop="express_up_id">
              <el-cascader
                v-model="searchArr.express_up_id"
                placeholder="请选择快递上传人"
                :options="adminUsersCustomer"
                size="mini"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="材料上传人" prop="file_up_id">
              <el-cascader
                v-model="searchArr.file_up_id"
                placeholder="请选择材料上传人"
                :options="adminUsersCustomer"
                size="mini"
                :props="{ expandTrigger: 'hover' }"
                clearable
                filterable
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="有无快递" prop="is_express">
              <el-radio-group v-model="searchArr.is_express" size="mini">
                <el-radio label="1" border>有快递</el-radio>
                <el-radio label="2" border>无快递</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="有无材料" prop="is_file">
              <el-radio-group v-model="searchArr.is_file" size="mini" @change="clearSome">
                <el-radio label="1" border>有材料</el-radio>
                <el-radio label="2" border>无材料</el-radio>
              </el-radio-group>
              <el-form-item
                label="是否下载过"
                prop="is_download"
                v-if="searchArr.is_file === '1'"
              >
                <el-radio-group v-model="searchArr.is_download" size="mini">
                  <el-radio label="1" border>未下载</el-radio>
                  <el-radio label="2" border>下载过</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="文件是否可用"
                prop="useable"
                v-if="searchArr.is_file === '1'"
              >
                <!-- <el-radio-group
                  v-model="searchArr.is_download"
                  size="mini"
                >
                  <el-radio label="1" border>未知</el-radio>
                  <el-radio label="2" border>不可用</el-radio>
                  <el-radio label="3" border>可用</el-radio>
                  <el-radio label="4" border>已记账</el-radio>
                </el-radio-group> -->
                <el-radio-group v-model="searchArr.useable" size="mini">
                  <el-radio-button label="0">未知</el-radio-button>
                  <el-radio-button label="1">不可用</el-radio-button>
                  <el-radio-button label="2">可用</el-radio-button>
                  <el-radio-button label="3">已记账</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form-item>
            <el-form-item label="有无档案" prop="archives">
              <el-radio-group v-model="searchArr.archives" size="mini">
                <el-radio label="1" border>有档案</el-radio>
                <el-radio label="2" border>无档案</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="tr">
              <el-button @click="handelClearSearch('searchForm')" size="mini"
                >重置</el-button
              >
              <el-button type="primary" @click="submitForm('searchForm')" size="mini"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
      <el-col :span="6" class="tr" style="line-height: 28px">
        <span>文件检查：</span>
        <el-link type="primary" @click="toCheckFile">个人微信</el-link>
        <el-link type="primary" @click="toCheckFileFromWxWork">企业微信</el-link>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="7" class="col-box">
        <el-row class="col-box-head">
          <div class="col-head-title">公司（{{ this.pageOption.total }}）</div>
        </el-row>
        <el-row class="col-com-items" v-scroll-loading="scrollBottom" ref="comList">
          <div
            class="col-box-item"
            :class="[fileSearchArr.cid === company.id ? 'active' : '']"
            v-for="company in companies"
            :key="company.id"
            @click="
              handelSelCom(
                company.id,
                company.company_name,
                company.express_count,
                company.wx_work_chat
              )
            "
          >
            <el-row>
              <el-col :span="17">
                <!-- <div class="col-box-centent"> -->
                <div style="white-space: nowrap">
                  <el-tooltip content="公司ID" placement="top" :open-delay="30">
                    <span>({{ company.id }})</span>
                  </el-tooltip>
                  <el-tooltip
                    :content="`${company.company_name}(${company.file_logs_sum_file_count ? company.file_logs_sum_file_count : 0})`"
                    placement="top"
                    :open-delay="500"
                    style="margin-right: 0.2rem; margin-left: 0.2rem"
                  >
                    <span>{{ company.company_name }}</span>
                  </el-tooltip>
                  <el-tooltip content="公司文件总数" placement="top" :open-delay="30">
                    <!-- <span style="border: 2px solid black;border-radius: 15px;background-color: rgb(236,226,252);width: 80px;height: 80px;text-align: center;display: inline-block">{{ company.company_file_count }}</span> -->
                    <div
                      style="
                        border: 2px solid black;
                        border-radius: 25px;
                        background-color: rgb(236, 226, 252);
                        width: 27px;
                        height: 20px;
                        text-align: center;
                        display: inline-block;
                        line-height: 20px;
                      "
                    >
                      {{ company.file_logs_sum_file_count ? company.file_logs_sum_file_count : 0 }}
                    </div>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :span="6" :offset="1" style="line-height: 0.8rem">
                <el-tooltip
                  v-if="company.file_logs_count > 0"
                  content="本月有文件"
                  placement="top"
                  :open-delay="500"
                >
                  <el-button
                    type="warning"
                    icon="el-icon-picture-outline-round"
                    circle
                    size="mini"
                    style="padding: 2px"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="company.express_count > 0"
                  content="快递"
                  placement="top"
                  :open-delay="500"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-truck"
                    circle
                    size="mini"
                    style="padding: 2px; margin: 0"
                  ></el-button>
                </el-tooltip>
              </el-col>
            </el-row>
          </div>
        </el-row>
      </el-col>
      <el-col :span="3" class="col-box">
        <el-row>
          <div class="col-box-head">
            <div class="col-head-title">文件分类</div>
          </div>
        </el-row>
        <el-row class="col-com-items" v-if="fileSearchArr.cid">
          <div
            class="col-box-item"
            :class="[fileSearchArr.type === 1 ? 'active' : '']"
            @click="handelSelType(1)"
          >
            <el-tooltip content="工资申报表" placement="top" :open-delay="500">
              <div class="col-box-centent">
                <span>工资申报表</span>
                <span style="">({{ setFileCount(1) }})</span>
              </div>
            </el-tooltip>
          </div>
          <div
            class="col-box-item"
            :class="[fileSearchArr.type === 2 ? 'active' : '']"
            @click="handelSelType(2)"
          >
            <el-tooltip content="开票汇总表" placement="top" :open-delay="500">
              <div class="col-box-centent">
                <span>开票汇总表</span>
                <span style="">({{ setFileCount(2) }})</span>
              </div>
            </el-tooltip>
          </div>
          <div
            class="col-box-item"
            :class="[fileSearchArr.type === 3 ? 'active' : '']"
            @click="handelSelType(3)"
          >
            <el-tooltip content="销项发票" placement="top" :open-delay="500">
              <div class="col-box-centent">
                <span>销项发票</span>
                <span style="">({{ setFileCount(3) }})</span>
              </div>
            </el-tooltip>
          </div>
          <div
            class="col-box-item"
            :class="[fileSearchArr.type === 4 ? 'active' : '']"
            @click="handelSelType(4)"
          >
            <el-tooltip content="银行回单" placement="top" :open-delay="500">
              <div class="col-box-centent">
                <span>银行回单</span>
                <span style="">({{ setFileCount(4) }})</span>
              </div>
            </el-tooltip>
          </div>
          <div
            class="col-box-item"
            :class="[fileSearchArr.type === 5 ? 'active' : '']"
            @click="handelSelType(5)"
          >
            <el-tooltip content="其他费用发票" placement="top" :open-delay="500">
              <div class="col-box-centent">
                <span>其他费用发票</span>
                <span style="">({{ setFileCount(5) }})</span>
              </div>
            </el-tooltip>
          </div>
          <div
            class="col-box-item"
            :class="[selExpress ? 'active' : '']"
            @click="handelSelExpress"
          >
            <el-tooltip content="快递记录" placement="top" :open-delay="500">
              <div class="col-box-centent">
                <span>快递材料</span>
                <span style="">({{ expressCount }})</span>
              </div>
            </el-tooltip>
          </div>
        </el-row>
      </el-col>
      <el-col :span="14" v-if="selExpress">
        <div class="files-head">
          <el-row>
            <el-col :span="18">
              <span class="files-head-title">快递记录</span>
            </el-col>
            <el-col :span="6">
              <div class="file-up">
                <el-tooltip content="添加" placement="top" :open-delay="500">
                  <i
                    class="el-icon-circle-plus file-up-icon"
                    @click="handleExpressOpen"
                  ></i>
                </el-tooltip>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row style="padding: 0 0.2rem">
          <el-table
            :data="express"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="快递公司" prop="express_name"></el-table-column>
            <el-table-column label="单号" prop="express_num">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.express_num" placement="top">
                  <el-link
                    class="hide-style"
                    type="primary"
                    @click="handelGetLogistics(scope.row)"
                    >{{ scope.row.express_num }}</el-link
                  >
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.phone" placement="top">
                  <span class="hide-style">{{ scope.row.phone }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="快递内容" prop="express_content">
              <template slot-scope="scope">
                <el-tooltip
                  :content="getExpressContent(scope.row.express_content)"
                  placement="top"
                >
                  <span class="hide-style">{{
                    getExpressContent(scope.row.express_content)
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="快递状态" prop="express_state">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.express_state === '未收到'"
                  type="primary"
                  @click="confirmState(scope.row.id, scope.row.express_num, scope.$index)"
                  >{{ scope.row.express_state }}</el-link
                >
                <span v-else>{{ scope.row.express_state }}</span>
              </template>
            </el-table-column>
            <el-table-column label="上传方式" prop="upload_mode"></el-table-column>
            <el-table-column label="上传人">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.upload_mode === '后端上传'"
                  :content="scope.row.admin.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.admin.username }}</span>
                </el-tooltip>
                <el-tooltip v-else :content="scope.row.user.name" placement="top">
                  <span class="hide-style">{{ scope.row.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="日期" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :small="true"
            class="tr mt-10"
            layout="total, prev, pager, next, jumper"
            :hide-on-single-page="false"
            :current-page="expressPageOption.currentPage"
            :page-size="expressPageOption.pageSize"
            :total="expressPageOption.total"
            @size-change="handleExpressSizeChange"
            @current-change="handleExpressCurrentChange"
          >
          </el-pagination>
        </el-row>
      </el-col>
      <el-col :span="14" v-else>
        <el-row>
          <div class="files-head">
            <el-row>
              <el-col :span="4">
                <span class="files-head-title">上传记录</span>
              </el-col>
              <el-col :span="20">
                <div class="file-up">
                  <el-button-group>
                    <el-button type="primary" size="mini" @click="handelUpFileOpen"
                      >上传</el-button
                    >
                    <el-button type="primary" size="mini" @click="handelBatchDownload"
                      >下载</el-button
                    >
                    <el-button type="primary" size="mini" @click="handelBatchDownloadAll"
                      >下载全部</el-button
                    >
                    <el-button type="primary" size="mini" @click="handleOpenAdvice"
                      >财税建议</el-button
                    >
                    <el-button type="primary" size="mini" @click="handelWxWorkChatOpen"
                      >聊天记录</el-button
                    >
                  </el-button-group>
                  <!--                   <el-tooltip content="上传" placement="top" :open-delay="500">
                    <i class="el-icon-upload2 file-up-icon" @click="handelUpFileOpen"></i>
                  </el-tooltip> -->
                </div>
              </el-col>
            </el-row>
          </div>
        </el-row>
        <el-row
          class="file-logs-box"
          v-scroll-loading="fileLogScrollBottom"
          ref="fileLogList"
        >
          <el-col :span="24" v-if="fileLogData.length > 0">
            <el-row class="mt-10" style="font-size: 0.26rem">
              <el-col :span="24">
                <span>累计文件：{{ companyFileCount.total }} </span>
                <span>未知：{{ companyFileCount.unknown }} </span>
                <span>不可用：{{ companyFileCount.not_available }} </span>
                <span>可用：{{ companyFileCount.available }} </span>
                <span>已记账：{{ companyFileCount.used }} </span>
              </el-col>
            </el-row>
            <div v-for="(log, index) in fileLogData" :key="log.id" class="mt-10">
              <el-card class="box-card" shadow="hover">
                <div slot="header">
                  <el-row>
                    <el-col :span="18">
                      <el-tooltip
                        :content="getTitle(log)"
                        placement="top"
                        :open-delay="500"
                      >
                        <span class="hide-style"
                          >{{ getTitle(log) }} 来源: {{ log.file_source }}</span
                        >
                      </el-tooltip>
                    </el-col>
                    <el-col
                      :span="6"
                      class="tr"
                      v-if="log.upload_mode === 1 && log.file_state === 0"
                    >
                      <el-link type="primary" @click="handelconfirmFile(log, index)"
                        >确认收到</el-link
                      >
                    </el-col>
                  </el-row>
                </div>
                <el-row>
                  <el-table
                    :data="log.files"
                    size="mini"
                    border
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    v-cloak
                  >
                    <el-table-column width="55">
                      <template slot-scope="scope">
                        <el-checkbox
                          :checked="is_checked"
                          @change="handleSelectionChange(scope.row, index, scope.$index)"
                        ></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column label="图标">
                      <template slot-scope="scope">
                        <svg class="icon svg-icon" aria-hidden="true">
                          <use :xlink:href="getIcon(scope.row.file_extension)"></use>
                        </svg>
                      </template>
                    </el-table-column>
                    <el-table-column label="文件名">
                      <template slot-scope="scope">
                        <el-tooltip
                          :content="
                            scope.row.file_name + '（' + scope.row.file_size + '）'
                          "
                          placement="top"
                          :open-delay="500"
                        >
                          <el-link
                            style="
                              text-overflow: ellipsis;
                              white-space: nowrap;
                              overflow: hidden;
                            "
                            @click="previewImage(scope.row.id)"
                            >{{ scope.row.file_name }}</el-link
                          >
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="文件状态"
                      prop="is_available"
                    ></el-table-column>
                    <el-table-column
                      label="下载次数"
                      prop="load_record_count"
                    ></el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="下载"
                          placement="top"
                        >
                          <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-download"
                            circle
                            @click="handelDownLoad(scope.row, index, scope.$index)"
                          ></el-button>
                        </el-tooltip>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="下载记录"
                          placement="top"
                        >
                          <el-button
                            type="success"
                            size="mini"
                            icon="el-icon-document-checked"
                            circle
                            @click="getLoadRecord(scope.row.id)"
                          ></el-button>
                        </el-tooltip>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="标记状态"
                          placement="top"
                        >
                          <el-button
                            type="warning"
                            size="mini"
                            icon="el-icon-paperclip"
                            circle
                            @click="
                              setFileAvailable(
                                scope.row.id,
                                index,
                                scope.$index,
                                scope.row.is_available
                              )
                            "
                          ></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!--                   <el-col :span="6" v-for="(file, idx) in log.files" :key="file.id">
                    <div class="file-box">
                      <el-tooltip :content="file.file_name + '（' + file.file_size + '）'" placement="top" :open-delay="500">
                        <div style="cursor: pointer" @click="handelDownLoad(file)">
                          <svg class="icon svg-icon" aria-hidden="true"><use :xlink:href="getIcon(file.file_extension)"></use></svg>
                        </div>
                      </el-tooltip>
                      <div style="padding: .1rem; font-size: .24rem; color: #5e6d82; text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
                        <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden">{{ file.file_name }}</div>
                        <div style="padding: .1rem 0; cursor: pointer; color: #409eff">
                          <span @click="getLoadRecord(file.id)">下载:{{ file.load_record_count }}</span>
                          <span @click="setFileAvailable(file.id, index, idx, file.is_available)" style="margin-left: .2rem">{{ file.is_available }}</span>
                        </div>
                      </div>
                    </div>
                  </el-col> -->
                </el-row>
                <el-row class="file-remark">
                  <el-tooltip :content="log.remark" placement="top" :open-delay="500">
                    <span>备注：{{ log.remark }}</span>
                  </el-tooltip>
                </el-row>
              </el-card>
            </div>
          </el-col>
          <el-col
            :span="24"
            v-else
            class="mt-10"
            style="text-align: center; color: #909399"
            >暂无数据</el-col
          >
        </el-row>
      </el-col>
    </el-row>
    <el-drawer
      title="上传文件"
      direction="rtl"
      :visible.sync="uploadDrawer"
      :before-close="handleUpClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <p style="margin-bottom: 0.2rem; text-align: center">
          {{ selComName }} - {{ nowDate }}
        </p>
        <el-form
          ref="upForm"
          :rules="upRules"
          :model="upForm"
          label-width="80px"
          size="mini"
        >
          <el-form-item label="文件类型" prop="file_type">
            <el-select v-model="upForm.file_type" placeholder="请选择文件类型">
              <el-option label="工资申报表" :value="1"></el-option>
              <el-option label="开票汇总表" :value="2"></el-option>
              <el-option label="销项发票" :value="3"></el-option>
              <el-option label="银行回单" :value="4"></el-option>
              <el-option label="其他费用发票" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件来源" prop="file_source">
            <el-select v-model="upForm.file_source" placeholder="请选择文件来源">
              <el-option label="微信" :value="2"></el-option>
              <el-option label="qq" :value="3"></el-option>
              <el-option label="邮箱" :value="4"></el-option>
              <el-option label="网盘" :value="5"></el-option>
              <el-option label="小程序" :value="6"></el-option>
              <el-option label="其他" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="upForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <el-row class="mt-10">
          <el-upload
            ref="upload"
            multiple
            action="#"
            :headers="uploadHeader"
            :on-change="fileChange"
            :on-remove="fileRemove"
            :auto-upload="false"
            :file-list="uploadedList"
            list-type="picture"
          >
            <el-link slot="trigger" type="primary">上传文件或图片</el-link>
          </el-upload>
        </el-row>
        <el-row class="mt-10">
          <el-input
            v-paste="handleParse"
            type="textarea"
            placeholder="请点击此处，再粘贴复制的截图"
          />
          <span style="color: red; font-size: 12px">注：粘贴只能上传图片</span>
        </el-row>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="submitUpload('upForm')"
            >上 传</el-button
          >
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="文件下载记录"
      direction="rtl"
      :visible.sync="loadRecordDrawer"
      :before-close="handleLoadRecordClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-timeline>
          <el-timeline-item
            v-for="record in loadRecords"
            :key="record.id"
            :timestamp="record.created_at"
            placement="top"
          >
            <el-card>
              <p style="line-height: 0.7rem">{{ record.admin.username }} 下载了该文件</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
    <el-drawer
      title="添加快递记录"
      direction="rtl"
      :visible.sync="addExpressDrawer"
      :before-close="handleExpressClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <p style="margin-bottom: 0.2rem; text-align: center">
          {{ selComName }} - {{ nowDate }}
        </p>
        <el-form
          ref="addExpressForm"
          :rules="addExpressRules"
          :model="addExpressForm"
          label-width="80px"
          size="mini"
        >
          <el-form-item label="快递公司" prop="express_name">
            <el-select v-model="addExpressForm.express_name" placeholder="请选择快递公司">
              <el-option value="SFEXPRESS" label="顺丰"></el-option>
              <el-option value="STO" label="申通"></el-option>
              <el-option value="YTO" label="圆通"></el-option>
              <el-option value="ZTO" label="中通"></el-option>
              <el-option value="HTKY" label="汇通"></el-option>
              <el-option value="YUNDA" label="韵达"></el-option>
              <el-option value="TTKDEX" label="天天"></el-option>
              <el-option value="JD" label="京东快递"></el-option>
              <el-option value="ZJS" label="宅急送"></el-option>
              <el-option value="CHINAPOST" label="EMS"></el-option>
              <el-option value="INTMAIL" label="EMS国际"></el-option>
              <el-option value="DEPPON" label="德邦"></el-option>
              <el-option value="HTKY" label="百世快递"></el-option>
              <el-option value="JITU" label="极兔速递"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="express_num">
            <el-input
              v-model="addExpressForm.express_num"
              clearable
              placeholder="请输入快递单号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="addExpressForm.phone"
              clearable
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="快递内容" prop="express_content">
            <el-select
              v-model="addExpressForm.express_content"
              multiple
              placeholder="请选择快递内容"
            >
              <el-option value="工资申报表" label="工资申报表"></el-option>
              <el-option value="开票汇总表" label="开票汇总表"></el-option>
              <el-option value="销项发票" label="销项发票"></el-option>
              <el-option value="银行回单" label="银行回单"></el-option>
              <el-option value="其他费用发票" label="其他费用发票"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递状态" prop="express_state">
            <el-select
              v-model="addExpressForm.express_state"
              placeholder="请选择快递状态"
            >
              <el-option :value="0" label="未收到"></el-option>
              <el-option :value="1" label="已收到"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button
            type="primary"
            size="mini"
            @click="submitAddExpress('addExpressForm')"
            >添 加</el-button
          >
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="物流信息"
      direction="rtl"
      :visible.sync="expressInfoDrawer"
      :before-close="handExpressInfoClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-timeline>
          <el-timeline-item
            class="logistics"
            v-for="(item, index) in expressInfo"
            :key="index"
            :timestamp="item.time"
          >
            {{ item.status }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
    <el-drawer
      title="财税建议"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleCloseIn"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -10px">
        <tax-advice :comId="adviceComId" :comName="adviceComName"></tax-advice>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      direction="rtl"
      :visible.sync="wxWorkChatDrawer"
      :before-close="handWxWorkChatClose"
      size="50%"
    >
      <div class="m-tabs-content">
        <el-row>
          <wx-work-chat
            :chatId="sCId"
            :chatName="sCName"
            @changeFile="changeFile"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog
      title="设置文件是否可用"
      :visible.sync="isAvailableVisible"
      width="40%"
      :before-close="handleIsAvailableClose"
    >
      <el-radio-group v-model="isAvailableForm.isAvailable">
        <el-radio label="未知">未知</el-radio>
        <el-radio label="不可用">不可用</el-radio>
        <el-radio label="可用">可用</el-radio>
        <el-radio label="已记账">已记账</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isAvailableVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="handleIsAvailableSub"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="previewImgDialog"
      width="40%"
      :before-close="handleClosePreviewImgDialog"
    >
      <div class="demo-image__preview" style="text-align: center">
        <el-image style="width: ; height: " :src="showUrl" :preview-src-list="[showUrl]">
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import TaxAdvice from "common/TaxAdvice";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "CompanyFiles",
  components: {
    WxWorkChat,
    TaxAdvice,
  },
  data() {
    return {
      direction: "rtl",
      uploadHeader: { Authorization: localStorage.token },
      visible: false,
      refundPicker: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              const todayDate = this.today();
              picker.$emit("pick", todayDate);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const yesterdayDate = this.yesterday();
              picker.$emit("pick", yesterdayDate);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              const thisWeekDate = this.thisWeek();
              picker.$emit("pick", thisWeekDate);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              const prevWeekDate = this.prevWeek();
              picker.$emit("pick", prevWeekDate);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              const thisMonDate = this.thisMon();
              picker.$emit("pick", thisMonDate);
            },
          },
          {
            text: "上月",
            onClick: (picker) => {
              const lastMonDate = this.lastMon();
              picker.$emit("pick", lastMonDate);
            },
          },
        ],
      },
      showUrl: null,
      previewImgDialog: false,
      img: [
        "png",
        "jpg",
        "bmp",
        "jpeg",
        "gif",
        "tif",
        "icns",
        "psd",
        "svg",
        "webp",
        "avif",
        "apng",
      ],
      companies: [],
      counts: null,
      companiesLoading: false,
      companiesComplete: false,
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
      },
      adminUsers: [],
      searchArr: {
        useable: "",
        is_download: "",
        company_id: null,
        leader_id: "",
        acc_id: "",
        ass_id: "",
        advisory_id: "",
        invoice_id: "",
        saler_id: "",
        is_express: null,
        is_file: null,
        express_up_id: null,
        file_up_id: null,
        created_at: "",
        archives: "",
      },
      selComName: "",
      adviceComId: null,
      adviceComName: null,
      categoryIndrawer: false,
      searchLoading: false,
      searchCompanies: [],
      fileLogData: [],
      fileCount: [],
      fileLogsLoading: false,
      fileLogsComplete: false,
      filePageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
      },
      fileSearchArr: {
        cid: null,
        type: null,
      },
      uploadDrawer: false,
      upForm: {
        cid: null,
        file_type: null,
        file_source: null,
        remark: "",
      },
      upRules: {
        file_type: [{ required: true, message: "请选择文件类型", trigger: "blur" }],
        file_source: [{ required: true, message: "请选择文件来源", trigger: "blur" }],
      },
      uploadedList: [],
      formData: null,
      loadRecords: [],
      loadRecordDrawer: false,
      selExpress: false,
      express: [],
      expressCount: 0,
      expressPageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
      },
      expressSearchArr: {
        cid: null,
      },
      addExpressDrawer: false,
      addExpressForm: {
        company_id: null,
        express_name: "",
        express_num: "",
        phone: "",
        express_content: [],
        express_state: 0,
      },
      addExpressRules: {
        express_name: [{ required: true, message: "请选择快递公司", trigger: "blur" }],
        express_num: [{ required: true, message: "请输入快递单号", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        express_content: [{ required: true, message: "请选择快递内容", trigger: "blur" }],
      },
      expressInfoDrawer: false,
      expressInfo: [],
      isAvailableVisible: false,
      isAvailableForm: {
        fileId: null,
        logIndex: null,
        fileIndex: null,
        isAvailable: "未知",
      },
      companyFileCount: {
        total: 0,
        unknown: 0,
        not_available: 0,
        available: 0,
        used: 0,
      },
      is_checked: false,
      multipleSelection: [],
      selectChatId: null,
      sCId: null,
      sCName: null,
      wxWorkChatDrawer: false,
      additionalData: { value: "无", label: "NULL" },
      additionalCustomerData: { value: "kh", label: "客户" },
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    fileSearchStr: function () {
      let str = "";
      for (let key in this.fileSearchArr) {
        str += "&" + key + "=" + this.fileSearchArr[key];
      }

      return str;
    },
    expressSearchStr: function () {
      let str = "";
      for (let key in this.expressSearchArr) {
        str += "&" + key + "=" + this.expressSearchArr[key];
      }

      return str;
    },
    nowDate: function () {
      let myDate = new Date();
      let year = myDate.getFullYear();
      let month = myDate.getMonth();
      month += 1;

      if (month.toString().length === 1) month = "0" + month;

      return year + "-" + month;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    adminUsersAddition() {
      return [...this.adminUsers, this.additionalData];
    },
    adminUsersCustomer() {
      return [...this.adminUsers, this.additionalCustomerData];
    },
  },
  methods: {
    clearSome(val) {
      if (val === "2") {
        this.searchArr.is_download = "";
        this.searchStr.useable = "";
      }
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getPageData(isSearch) {
      isSearch = isSearch || false;
      this.is_checked = false;
      this.$axios
        .get(
          "/api/admin/companies_files/companies?page=" +
            this.pageOption.currentPage +
            this.searchStr
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            if (!isSearch) {
              this.companies.push(...data.data.pageData.data);
              this.companiesLoading = true;
            } else {
              this.companies = data.data.pageData.data;
              this.companiesLoading = false;
            }
            this.adminUsers = data.data.adminUsers;
            this.pageOption.total = data.data.pageData.total;
            this.companiesComplete = data.data.pageData.data.length === 0;
            this.getCounts();
          }
        });
    },
    getCounts(){
      this.$axios.get('/api/admin/companies_files/counts?page=' + this.pageOption.currentPage + this.searchStr, { loadingClose: true })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.counts = data.data.counts;
          }
        })
    },
    searchRemoteCompanyMethod(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchArrItemCompanys(query);
        }, 200);
      } else {
        this.searchCompanies = [];
      }
    },
    searchArrItemCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.searchCompanies = data.data.companies;
        }
      });
    },
    handleSearchCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.fileSearchArr.cid = null;
      this.fileSearchArr.type = null;
      this.fileLogData = [];
      this.expressSearchArr.cid = null;
      this.selExpress = false;
      this.express = [];
      this.expressPageOption.total = 0;
      this.expressPageOption.currentPage = 1;
      this.getPageData(true);
    },
    createdAtChange(val) {
      this.submitForm("searchForm");
    },
    handelClearSearch(formName) {
      this.searchArr.company_id = null;
      this.searchArr.created_at = "";
      this.resetForm(formName);
      this.pageOption.currentPage = 1;
      this.fileSearchArr.cid = null;
      this.fileSearchArr.type = null;
      this.fileLogData = [];
      this.expressSearchArr.cid = null;
      this.selExpress = false;
      this.express = [];
      this.expressPageOption.total = 0;
      this.expressPageOption.currentPage = 1;
      this.visible = false;
      this.getPageData(true);
    },
    submitForm(formName) {
      this.pageOption.currentPage = 1;
      this.fileSearchArr.cid = null;
      this.fileSearchArr.type = null;
      this.fileLogData = [];
      this.expressSearchArr.cid = null;
      this.selExpress = false;
      this.express = [];
      this.expressPageOption.total = 0;
      this.expressPageOption.currentPage = 1;
      this.visible = false;
      this.getPageData(true);
    },
    scrollBottom() {
      let scrollTop = this.$refs.comList.$el.scrollTop;
      let height = this.$refs.comList.$el.scrollHeight;
      let clientHeight = this.$refs.comList.$el.clientHeight;

      if (scrollTop + clientHeight === height && this.companiesLoading) {
        if (!this.companiesComplete) this.pageOption.currentPage++;
        this.getPageData();
      }

      this.companiesLoading = true;
    },
    handelSelCom(cid, cName, expressCount, wxWorkChat) {
      if (cid === this.fileSearchArr.cid) return;
      this.fileSearchArr.cid = cid;
      this.selectChatId = wxWorkChat ? wxWorkChat.chat_id : null;
      this.selComName = cName;
      this.fileSearchArr.type = null;
      this.filePageOption.currentPage = 1;
      this.fileLogsLoading = false;
      this.fileLogsComplete = false;
      this.fileLogData = [];
      this.expressSearchArr.cid = cid;
      this.selExpress = false;
      this.express = [];
      this.expressCount = expressCount;
      this.expressPageOption.total = 0;
      this.expressPageOption.currentPage = 1;
      this.getFileLogs();
    },
    handelSelType(type) {
      this.fileSearchArr.type = type;
      this.selExpress = false;
      this.fileLogData = [];
      this.filePageOption.currentPage = 1;
      this.fileLogsLoading = false;
      this.fileLogsComplete = false;
      this.getFileLogs();
    },
    getFileLogs(isSearch) {
      isSearch = isSearch || false;
      this.is_checked = false;
      this.$axios
        .get(
          "/api/admin/companies_files/file_logs?page=" +
            this.filePageOption.currentPage +
            this.fileSearchStr +
            "&date=" +
            this.searchArr.created_at
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            if (!isSearch) {
              data.data.fileLogs.data.map((item) => {
                if (!this.fileLogData.includes(item)) {
                  this.fileLogData.push(item);
                }
              });
              // this.fileLogData.push(...data.data.fileLogs.data)
              this.fileLogsLoading = true;
            } else {
              this.fileLogData = data.data.fileLogs.data;
              this.fileLogsLoading = false;
            }
            this.filePageOption.total = data.data.fileLogs.total;
            this.fileLogsComplete = data.data.fileLogs.data.length === 0;
            this.fileCount = data.data.fileCount;
            this.companyFileCount.total = data.data.companyFileCount.total;
            this.companyFileCount.unknown = data.data.companyFileCount.unknown;
            this.companyFileCount.not_available =
              data.data.companyFileCount.not_available;
            this.companyFileCount.available = data.data.companyFileCount.available;
            this.companyFileCount.used = data.data.companyFileCount.used;
            this.expressCount = data.data.expressCount;
          }
        });
    },
    setFileCount(num) {
      let count = 0;
      for (var i = 0; i < this.fileCount.length; i++) {
        if (num === this.fileCount[i].file_type) {
          count = this.fileCount[i].file_count;
        }
      }

      return count;
    },
    fileLogScrollBottom() {
      let scrollTop = this.$refs.fileLogList.$el.scrollTop;
      let height = this.$refs.fileLogList.$el.scrollHeight;
      let clientHeight = this.$refs.fileLogList.$el.clientHeight;

      if (scrollTop + clientHeight === height && this.fileLogsLoading) {
        if (!this.fileLogsComplete) this.filePageOption.currentPage++;
        this.getFileLogs();
      }

      this.fileLogsLoading = true;
    },
    getTitle(log) {
      let str = "";
      let date = this.formattedDate(log.created_at);

      if (log.upload_mode === 1) {
        if (log.user) {
          str = "客户 " + log.user.name + " 于 " + date + " 上传了文件";
        } else {
          str = "客户 " + "　" + " 于 " + date + " 上传了文件";
        }

        return str;
      }

      if (log.upload_mode === 2) {
        str = "后端 " + log.admin.username + " 于 " + date + " 上传了文件";
      }

      return str;
    },
    formattedDate(dateValue) {
      let date = new Date(dateValue);
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      let hours = date.getHours().toString().padStart(2, "0");
      let minutes = date.getMinutes().toString().padStart(2, "0");
      let seconds = date.getSeconds().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getIcon(extension) {
      let icon = "#youkai-wenjianleixing-biaozhuntu-weizhiwenjian";

      if (
        extension === "png" ||
        extension === "PNG" ||
        extension === "jpg" ||
        extension === "jpeg" ||
        extension === "gif"
      ) {
        icon = "#youkai-tupian";
      }

      if (extension === "doc" || extension === "docx") {
        icon = "#youkai-docx";
      }

      if (extension === "xls" || extension === "xlsx" || extension === "csv") {
        icon = "#youkai-xlsx";
      }

      if (extension === "pdf") {
        icon = "#youkai-pdf";
      }

      if (extension === "zip" || extension === "rar") {
        icon = "#youkai-rar";
      }

      return icon;
    },
    handelDateChange(val) {
      if (!this.fileSearchArr.cid) return;
      this.filePageOption.currentPage = 1;
      this.getFileLogs(true);
    },
    handelUpFileOpen() {
      if (!this.fileSearchArr.cid) {
        this.$message.error("请先选择公司");
        return;
      }

      this.upForm.cid = this.fileSearchArr.cid;
      this.upForm.file_type = this.fileSearchArr.type;
      this.formData = new FormData();
      this.uploadDrawer = true;
    },
    fileChange(file, fileList) {
      let size = 0;

      for (var i = 0; i < fileList.length; i++) {
        size += fileList[i].size;
      }

      let isLt5M = size / 1024 / 1024 < 50;
      if (!isLt5M) {
        this.$message.error("上传文件总大小不能超过 50MB");
        fileList = [];
        this.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      }
      this.uploadedList = fileList;
    },
    fileRemove(file, fileList) {
      this.uploadedList = fileList;
    },
    submitUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.uploadedList.length === 0) {
            this.$message.error("请上传文件");
            return;
          }
          this.uploadedList.forEach((file) => this.formData.append("file[]", file.raw));
          for (let key in this.upForm) {
            this.formData.append(key, this.upForm[key]);
          }

          this.$axios.post("/api/admin/companies_files", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              for (var i = 0; i < this.companies.length; i++) {
                if (this.companies[i].id === this.upForm.cid) {
                  this.companies[i].file_logs_count += 1;
                }
              }

              this.uploadDrawer = false;
              this.clearUpForm();
              this.$message.success(data.msg);
              this.filePageOption.currentPage = 1;
              this.handelSelType(this.fileSearchArr.type);
            }
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    clearUpForm() {
      this.resetForm("upForm");
      this.upForm.cid = null;
      this.formData = null;
      this.uploadedList = [];
    },
    handleUpClose(done) {
      this.clearUpForm();
      done();
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          that.uploadedList.push(fileObj);
        };
      } else {
        this.$message.warning("粘贴的文件必须为图片");
      }
    },
    handelDownLoad(file, logIndex, fileIndex) {
      this.$axios
        .post(
          "/api/admin/companies_files/file_load",
          { file_id: file.id, path: file.file_path },
          { responseType: "blob" }
        )
        .then((res) => {
          console.log(res.statusText);
          if (res.statusText === "OK") {
            this.fileLogData[logIndex].files[fileIndex].load_record_count++;
          }
          let blob = new Blob([res.data]);
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = file.file_name;
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 100);
        });
    },
    handelDownLoadAll(file, logIndex, fileIndex, dataAll) {
      this.$axios
        .post(
          "/api/admin/companies_files/file_load",
          { file_id: file.id, path: file.file_path },
          { responseType: "blob" }
        )
        .then((res) => {
          console.log(res.statusText);
          if (res.statusText === "OK") {
            // dataAll[logIndex].files[fileIndex].load_record_count++
            this.fileLogData[logIndex].files[fileIndex].load_record_count++;
          }
          let blob = new Blob([res.data]);
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = file.file_name;
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 300 * 1000);
        });
    },
    getLoadRecord(fileId) {
      this.$axios
        .post("/api/admin/companies_files/load_record", { fileId: fileId })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.loadRecords = data.data.loadRecords;
            this.loadRecordDrawer = true;
          }
        });
    },
    setFileAvailable(fileId, logIndex, fileIndex, isAvailable) {
      this.isAvailableForm.fileId = fileId;
      this.isAvailableForm.logIndex = logIndex;
      this.isAvailableForm.fileIndex = fileIndex;
      this.isAvailableForm.isAvailable = isAvailable;
      this.isAvailableVisible = true;
    },
    clearIsAvailableForm() {
      this.isAvailableForm.fileId = null;
      this.isAvailableForm.logIndex = null;
      this.isAvailableForm.fileIndex = null;
      this.isAvailableForm.isAvailable = "未知";
    },
    handleIsAvailableClose(done) {
      this.clearIsAvailableForm();
      done();
    },
    handleClosePreviewImgDialog(done) {
      this.showUrl = null;
      done();
    },
    handleOpenAdvice() {
      if (!this.fileSearchArr.cid) {
        this.$message.error("请先选择公司");
        return;
      }
      this.adviceComId = this.fileSearchArr.cid;
      this.adviceComName = this.selComName;
      this.categoryIndrawer = true;
    },
    handleCloseIn(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          setTimeout(() => {
            this.adviceComId = null;
            // this.$refs.categoryForm.resetFields()
            // this.$refs.uploadMutiple.clearFiles()
            this.needUrl = [];
          });
          done();
        })
        .catch((_) => {});
    },
    handleIsAvailableSub() {
      this.$axios
        .post("/api/admin/companies_files/available", this.isAvailableForm)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.fileLogData[this.isAvailableForm.logIndex].files[
              this.isAvailableForm.fileIndex
            ].is_available = this.isAvailableForm.isAvailable;
            this.clearIsAvailableForm();
            this.isAvailableVisible = false;
            this.$message.success(data.msg);
          }
        });
    },
    handleLoadRecordClose(done) {
      this.loadRecords = [];
      done();
    },
    handleExpressOpen() {
      this.addExpressForm.company_id = this.expressSearchArr.cid;
      this.addExpressDrawer = true;
    },
    clearExpressClose() {
      this.addExpressForm.company_id = null;
      this.resetForm("addExpressForm");
    },
    handleExpressClose(done) {
      this.clearExpressClose();
      done();
    },
    submitAddExpress(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/admin/companies_express", this.addExpressForm)
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.addExpressDrawer = false;
                this.clearExpressClose();
                this.getExpress();
              }
            });
        }
      });
    },
    handelSelExpress() {
      this.selExpress = true;
      this.fileSearchArr.type = null;
      this.fileLogData = [];
      this.filePageOption.currentPage = 1;
      this.fileLogsLoading = false;
      this.fileLogsComplete = false;
      this.getExpress();
    },
    getExpress() {
      this.$axios
        .get(
          "/api/admin/companies_express/" +
            this.expressSearchArr.cid +
            "?page=" +
            this.expressPageOption.currentPage +
            this.expressSearchStr +
            "&date=" +
            this.searchArr.created_at
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.express = data.data.express.data;
            this.expressPageOption.total = data.data.express.total;
            this.expressCount = data.data.express.total;
            this.fileCount = data.data.fileCount;
          }
        });
    },
    handleExpressSizeChange(val) {
      this.expressPageOption.pageSize = val;
    },
    handleExpressCurrentChange(val) {
      this.expressPageOption.currentPage = val;
      this.getExpress();
    },
    handelExpressDateChange(val) {
      if (!this.expressSearchArr.cid) return;
      this.expressPageOption.currentPage = 1;
      this.getExpress();
    },
    getExpressContent(content) {
      let str = "";
      for (var i = 0; i < content.length; i++) {
        str += content[i] + ",";
      }

      return str;
    },
    handelGetLogistics(express) {
      this.$axios
        .post("/api/admin/companies_express/info/" + express.id, express)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.expressInfo = data.data.logistics;
            this.expressInfoDrawer = true;
          }
        });
    },
    handExpressInfoClose(done) {
      this.expressInfo = [];
      done();
    },
    handelconfirmFile(log, index) {
      this.$confirm("确认将该状态标记为已收到吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.setFileState(log, index);
        })
        .catch(() => {});
    },
    setFileState(log, index) {
      this.$axios
        .post("/api/admin/companies_files/state", {
          lid: log.id,
          uid: log.user_id,
          fileType: log.file_type,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.fileLogData[index].file_state = 1;
            this.$message.success(data.msg);
          }
        });
    },
    confirmState(eid, expressNum, index) {
      this.$confirm("确认将该状态标记为已收到吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.setExpressState(eid, expressNum, index);
        })
        .catch(() => {});
    },
    setExpressState(eid, expressNum, index) {
      this.$axios
        .post("/api/admin/companies_express/state", {
          eid: eid,
          expressNum: expressNum,
          cid: this.expressSearchArr.cid,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.express[index].express_state = "已收到";
            this.$message.success(data.msg);
          }
        });
    },
    toCheckFile() {
      this.$router.push("/qy_chat_messages");
    },
    toCheckFileFromWxWork() {
      this.$router.push("/wxwork_file_messages");
    },
    handleSelectionChange(row, logIndex, fileIndex) {
      row.logIndex = logIndex;
      row.fileIndex = fileIndex;
      let index = this.multipleSelection.indexOf(row);
      if (index === -1) {
        this.multipleSelection.push(row);
      } else {
        this.multipleSelection.splice(index, 1);
      }
      console.log(this.multipleSelection);
    },
    handelBatchDownload() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请选择文件");
        return;
      }

      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.handelDownLoad(
          this.multipleSelection[i],
          this.multipleSelection[i].logIndex,
          this.multipleSelection[i].fileIndex
        );
      }

      // this.$axios.post('/api/admin/companies_files/batch/file_load', this.multipleSelection)
      //   .then((res) => {})
    },
    // handelBatchDownloadAll () {
    //   if (this.fileLogData.length === 0) {
    //     this.$message.error('文件不存在')
    //     return
    //   }

    //   for (let i = 0; i < this.fileLogData.length; i++) {
    //     // console.log(this.fileLogData[i].files)
    //     for (let j = 0; j < this.fileLogData[i].files.length; j++) {
    //       if (
    //         this.fileLogData[i].files[j].file_extension === 'pdf' ||
    //         this.fileLogData[i].files[j].file_extension === 'PDF'
    //       ) {
    //         setTimeout(() => {
    //           this.handelDownLoad(this.fileLogData[i].files[j], i, j)
    //         })
    //       } else {
    //         setTimeout(() => {
    //           this.getFileUrl(this.fileLogData[i].files[j], i, j)
    //         })
    //       }
    //     }
    //   }
    // },
    handelBatchDownloadAll() {
      this.fileLogData = [];
      this.multipleSelection = [];
      this.$axios
        .get(
          "/api/admin/companies_files/file_logs_all?a=1" +
            this.fileSearchStr +
            "&date=" +
            this.searchArr.created_at
        )
        .then(({ data }) => {
          this.initData(data);
        })
        .catch();
    },
    initData(data) {
      this.fileLogData = data;

      this.is_checked = true;

      if (data.length === 0) {
        this.$message.error("文件不存在");
        return;
      }

      for (let i = 0; i < data.length; i++) {
        // console.log(data[i].files)
        for (let j = 0; j < data[i].files.length; j++) {
          if (
            data[i].files[j].file_extension === "pdf" ||
            data[i].files[j].file_extension === "PDF"
          ) {
            setTimeout(() => {
              this.handelDownLoadAll(data[i].files[j], i, j, data);
            });
          } else {
            setTimeout(() => {
              this.getFileUrlAll(data[i].files[j], i, j, data);
            });
          }
        }
      }
    },
    getFileUrl(file, logIndex, fileIndex) {
      this.$axios
        .post("/api/admin/companies_files/file_sig_url", {
          file_id: file.id,
          path: file.file_path,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            // window.open(data.data.signedUrl)
            this.fileLogData[logIndex].files[fileIndex].load_record_count++;
            let iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.style.height = 0;
            iframe.src = data.data.signedUrl;
            document.body.appendChild(iframe);
            setTimeout(function () {
              iframe.remove();
            }, 1000);
          }
        });
    },
    getFileUrlAll(file, logIndex, fileIndex, dataAll) {
      this.$axios
        .post("/api/admin/companies_files/file_sig_url", {
          file_id: file.id,
          path: file.file_path,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            // window.open(data.data.signedUrl)
            // dataAll[logIndex].files[fileIndex].load_record_count++
            this.fileLogData[logIndex].files[fileIndex].load_record_count++;
            let iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.style.height = 0;
            iframe.src = data.data.signedUrl;
            document.body.appendChild(iframe);
            setTimeout(function () {
              iframe.remove();
            }, 300 * 1000);
          }
        });
    },
    handelWxWorkChatOpen() {
      if (!this.selectChatId) {
        this.$message.error("该公司未绑定群，请前去企业微信群管理绑定该公司");
        return;
      }
      this.wxWorkChatDrawer = true;
      setTimeout(() => {
        this.sCId = this.selectChatId;
        this.sCName = this.selComName;
      });
    },
    handWxWorkChatClose(done) {
      this.sCId = null;
      this.sCName = null;
      done();
    },
    changeFile() {
      this.selExpress = false;
      this.fileLogData = [];
      this.filePageOption.currentPage = 1;
      this.fileLogsLoading = false;
      this.fileLogsComplete = false;
      this.getFileLogs();
    },
    today() {
      return [new Date(), new Date()];
    },
    yesterday() {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24);

      return [date, date];
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    prevWeek() {
      var end = new Date();
      var start = new Date();
      var lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);

      return [start, end];
    },
    thisMon() {
      var end = new Date();
      var start = new Date();
      // 方法1
      var endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    lastMon() {
      var end = new Date();
      var start = new Date();
      var year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      var febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天

      return [start, end];
    },
    previewImage(id) {
      this.$axios
        .get("api/admin/companies_files/get_oss_path", {
          params: {
            id,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            if (data.data[0] && this.img.indexOf(data.data[0].toLowerCase()) !== -1) {
              this.showImg(data.data[1]);
            } else if (
              data.data[0] &&
              ["pdf"].indexOf(data.data[0].toLowerCase()) !== -1
            ) {
              window.open(data.data[1]);
            }
          }
        })
        .catch();
    },
    showImg(url) {
      this.showUrl = url;
      this.previewImgDialog = true;
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    this.getPageData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-form .el-select {
  width: 100%;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.el-drawer .el-form-item {
  margin-bottom: 0.3rem !important;
}

.el-timeline >>> .el-timeline-item__content {
  line-height: 1.7;
  margin-bottom: 0.3rem !important;
}

.companyFiles >>> .el-card__header {
  padding: 0.2rem;
  font-size: 0.26rem;
}

.companyFiles >>> .el-card__body {
  padding: 0.1rem;
}

.companyFiles >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.companyFiles {
  marginLeft();

  .hide-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.el-button+.el-button {
  margin-left: 0;
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-dialog .el-select {
  width: 100%;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}

.active {
  background-color: #f5f5f5;
  color: #409eff;
}

.col-box {
  min-height: calc(100vh - 210px);
  border-right: 1px solid #ebebeb;

  .col-box-head {
    height: 0.56rem;
    padding: 0 0.2rem;
    overflow: hidden;

    .col-head-title {
      line-height: 0.56rem;
      color: #5789f4;
    }
  }

  .col-com-items {
    min-height: calc(100vh - 210px);
    height: 6rem;
    overflow-y: auto;
    padding: 0 0.2rem;
  }

  .col-box-item:hover {
    background-color: #f5f5f5;
  }

  .col-box-item {
    height: 0.8rem;
    line-height: 0.8rem;
    cursor: pointer;
    border-bottom: 1px solid #ebebeb;

    .col-box-centent {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

.files-head {
  height: 0.56rem;
  line-height: 0.56rem;
  padding: 0 0.2rem;

  .files-head-title {
    color: #5789f4;
  }

  .file-up {
    color: #5789f4;
    text-align: right;
    font-size: 0.5rem;

    .file-up-icon {
      cursor: pointer;
    }
  }
}

.up-link {
  width: 1.4rem;
  text-align: right;
}

.file-logs-box {
  min-height: calc(100vh - 210px);
  height: 6rem;
  padding: 0 0.2rem;
  overflow-y: auto;

  .file-box {
    display: flex;
  }

  .file-remark {
    color: rgb(94, 109, 130);
    font-size: 0.26rem;
    padding: 0.1rem;
  }
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-icon {
  font-size: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/companies/CompanyFiles.vue